module.exports = __webpack_public_path__ + "media/images/icons/star-half-2fb80baa31ae667a7acbb802b8d760ea.svg";